// @ts-strict-ignore
import { getOutgoers } from 'react-flow-renderer';

/** Get all children recursively of a passed in parent node
  * @param {Object} initialParentNode
  * @param {Array} Nodes - All of the React Flow Nodes in the graph
  * @param {Array} Edges - All of the React Flow Edges in the graph
  * @returns {Array} An array of React Flow Nodes
  */
export function getOutgoersRecursively(initialParentNode, nodes, edges) {
  return getOutgoers(initialParentNode, nodes, edges).reduce((allOutgoers, outgoer) => ([
    ...allOutgoers,
    outgoer,
    ...getOutgoersRecursively(outgoer, nodes, edges),
  ]), []);
}
